import { render, staticRenderFns } from "./SubscribesComp.vue?vue&type=template&id=c745055c&scoped=true&"
import script from "./SubscribesComp.vue?vue&type=script&lang=js&"
export * from "./SubscribesComp.vue?vue&type=script&lang=js&"
import style0 from "./SubscribesComp.vue?vue&type=style&index=0&id=c745055c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c745055c",
  null
  
)

export default component.exports